import type { CatalogItem } from '@/types/domain';

const fromRef = (row: {
  id: number;
  name: string;
  cat: CatalogItem['category'];
  sku: string;
  list: number;
  accent: string;
  stock: number;
  tag?: string;
}): CatalogItem => ({
  id: row.id.toString(),
  qboItemId: row.id,
  name: row.name,
  sku: row.sku,
  category: row.cat,
  unit: row.cat,
  listPrice: row.list,
  qtyOnHand: row.stock,
  entity: 'AS',
  accentColor: row.accent,
  tag: row.tag ?? null,
  orderable: true,
  active: true,
  imageUrl: null,
  imageThumbUrl: null,
  bibImageUrl: null,
  description: null,
  sfItemId: null,
  sfItemCode: null,
  sfItemName: null,
  displayName: null,
  packSize: null,
  volumeOz: null,
  weightLbs: null,
  containerType: null,
  dimensionsIn: null,
});

export const CATALOG_FIXTURE: CatalogItem[] = [
  fromRef({ id: 222, name: 'Hangar 25 Cola',          cat: '3-gal BIB', sku: '3G6121', list: 90, accent: '#7A4A2B', stock: 370 }),
  fromRef({ id: 205, name: 'Hangar 25 Diet Cola',     cat: '3-gal BIB', sku: '3G1091', list: 79, accent: '#3A3F45', stock: 263 }),
  fromRef({ id: 224, name: 'Cable Car Lemon Lime',    cat: '3-gal BIB', sku: '3G6141', list: 79, accent: '#9BC53D', stock: 206, tag: 'Bestseller' }),
  fromRef({ id: 225, name: 'Oaktown Root Beer',       cat: '3-gal BIB', sku: '3G6151', list: 74, accent: '#5C3B26', stock: 236 }),
  fromRef({ id: 226, name: 'Lost Island Ginger Beer', cat: '3-gal BIB', sku: '3G6471', list: 79, accent: '#D4A24C', stock: 138 }),
  fromRef({ id: 227, name: 'Golden Gate Orange',      cat: '3-gal BIB', sku: '3G6481', list: 79, accent: '#F26A21', stock: 78 }),
  fromRef({ id: 228, name: 'Olde Fountain Creme',     cat: '3-gal BIB', sku: '3G6491', list: 74, accent: '#E8D5A8', stock: 88 }),
  fromRef({ id: 229, name: 'Diablo Black Cherry',     cat: '3-gal BIB', sku: '3G6501', list: 90, accent: '#4A1B2E', stock: 100 }),
  fromRef({ id: 230, name: 'Grand Lake Grapefruit',   cat: '3-gal BIB', sku: '3G6511', list: 74, accent: '#F5A395', stock: 46 }),
  fromRef({ id: 207, name: 'Docteur Poivre',          cat: '3-gal BIB', sku: '3G1911', list: 74, accent: '#6B4423', stock: 21 }),
  fromRef({ id: 223, name: 'APT Ginger Ale',          cat: '3-gal BIB', sku: '3G6131', list: 74, accent: '#D4A24C', stock: 60 }),
  fromRef({ id: 206, name: 'APT Tonic',               cat: '3-gal BIB', sku: '3G1141', list: 74, accent: '#C8D4D8', stock: 43 }),

  fromRef({ id: 208, name: 'APT Apple',         cat: 'Mixer', sku: '3G2011', list: 110, accent: '#B8C95F', stock: 22 }),
  fromRef({ id: 209, name: 'APT Cranberry',     cat: 'Mixer', sku: '3G2051', list: 110, accent: '#8B2942', stock: 113 }),
  fromRef({ id: 211, name: 'APT Fruit Punch',   cat: 'Mixer', sku: '3G2071', list: 80,  accent: '#D9482B', stock: 28 }),
  fromRef({ id: 214, name: 'APT Orange Juice',  cat: 'Mixer', sku: '3G2121', list: 110, accent: '#F26A21', stock: 46 }),
  fromRef({ id: 215, name: 'APT Pineapple',     cat: 'Mixer', sku: '3G2151', list: 110, accent: '#E8B547', stock: 76 }),
  fromRef({ id: 216, name: 'APT Sweet & Sour',  cat: 'Mixer', sku: '3G2161', list: 92,  accent: '#EFD679', stock: 29 }),
  fromRef({ id: 217, name: 'APT Meyer Lemonade',cat: 'Mixer', sku: '3G2491', list: 83,  accent: '#F4D14B', stock: 172 }),
  fromRef({ id: 218, name: 'APT Tea',           cat: 'Mixer', sku: '3G3041', list: 74,  accent: '#9B7B4A', stock: 77 }),
  fromRef({ id: 221, name: 'APT Energy',        cat: 'Mixer', sku: '3G5011', list: 150, accent: '#3A8DD9', stock: 29 }),

  fromRef({ id: 240, name: 'Hangar 25 Cola',       cat: '5-gal BIB', sku: '5G6121', list: 110, accent: '#7A4A2B', stock: 70 }),
  fromRef({ id: 233, name: 'Hangar 25 Diet Cola',  cat: '5-gal BIB', sku: '5G1091', list: 110, accent: '#3A3F45', stock: 46 }),
  fromRef({ id: 242, name: 'Cable Car Lemon Lime', cat: '5-gal BIB', sku: '5G6141', list: 110, accent: '#9BC53D', stock: 40 }),

  fromRef({ id: 232, name: 'Cable Car LL — Sugar Free',       cat: 'Sugar Free', sku: '3GSF412', list: 75, accent: '#9BC53D', stock: 0 }),
  fromRef({ id: 310, name: 'Docteur Poivre — Sugar Free',     cat: 'Sugar Free', sku: '3GSF112', list: 90, accent: '#6B4423', stock: 14 }),
  fromRef({ id: 312, name: 'Oaktown Root Beer — Sugar Free',  cat: 'Sugar Free', sku: '3GSF512', list: 90, accent: '#5C3B26', stock: 17 }),
  fromRef({ id: 313, name: 'APT Ginger Ale — Sugar Free',     cat: 'Sugar Free', sku: '3GSF312', list: 90, accent: '#D4A24C', stock: 20 }),
  fromRef({ id: 308, name: 'APT Meyer Lemonade — Sugar Free', cat: 'Sugar Free', sku: '3GSF912', list: 90, accent: '#F4D14B', stock: 15 }),
  fromRef({ id: 309, name: 'APT Peach Tea — Sugar Free',      cat: 'Sugar Free', sku: '3GSF053', list: 90, accent: '#E8975E', stock: 16 }),

  fromRef({ id: 572, name: 'Hangar 25 Cola',          cat: '24-Pack', sku: '24P126121', list: 32, accent: '#7A4A2B', stock: 247 }),
  fromRef({ id: 570, name: 'Hangar 25 Diet Cola',     cat: '24-Pack', sku: '24P121091', list: 32, accent: '#3A3F45', stock: 498 }),
  fromRef({ id: 573, name: 'Cable Car Lemon Lime',    cat: '24-Pack', sku: '24P126141', list: 32, accent: '#9BC53D', stock: 424 }),
  fromRef({ id: 574, name: 'Oaktown Root Beer',       cat: '24-Pack', sku: '24P126151', list: 32, accent: '#5C3B26', stock: 1160 }),
  fromRef({ id: 576, name: 'Lost Island Ginger Beer', cat: '24-Pack', sku: '24P126471', list: 32, accent: '#D4A24C', stock: 410 }),
  fromRef({ id: 575, name: 'Golden Gate Orange',      cat: '24-Pack', sku: '24P126481', list: 32, accent: '#F26A21', stock: 627 }),
  fromRef({ id: 560, name: 'Olde Fountain Creme',     cat: '24-Pack', sku: '24P126491', list: 32, accent: '#E8D5A8', stock: 198 }),

  fromRef({ id: 472, name: 'CO₂ Cylinder 10 LB', cat: 'Gas', sku: 'CO8010', list: 38, accent: '#6A7780', stock: 1 }),
];

export const MELT_PRICING_FIXTURE: Record<string, number> = {
  '222': 68, '205': 68, '224': 68, '225': 68, '226': 68, '227': 68, '228': 68,
  '229': 68, '230': 68, '207': 68, '223': 68, '206': 68,
};

export function resolveFixturePrice(item: CatalogItem, qboCustomerId: number): number {
  if (qboCustomerId === 1418 && MELT_PRICING_FIXTURE[item.id] !== undefined) {
    return MELT_PRICING_FIXTURE[item.id] as number;
  }
  return item.listPrice;
}
